'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _shopifySectionsManager = require('shopify-sections-manager');

var _shopifySectionsManager2 = _interopRequireDefault(_shopifySectionsManager);

var _StaticProductReact = require('../sections/StaticProductReact');

var _StaticProductReact2 = _interopRequireDefault(_StaticProductReact);

var _ProductFeatures = require('../sections/ProductFeatures');

var _ProductFeatures2 = _interopRequireDefault(_ProductFeatures);

require('intersection-observer');

var _rimgShopify = require('rimg-shopify');

var _rimgShopify2 = _interopRequireDefault(_rimgShopify);

require('../../styles/templates/product.scss');

var _StaticExitIntent = require('../sections/StaticExitIntent');

var _StaticExitIntent2 = _interopRequireDefault(_StaticExitIntent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sections = window.shopifySections || new _shopifySectionsManager2.default();

var reloadSection = function reloadSection(sectionId) {
  var target = document.querySelector('[data-section-type="' + sectionId + '"]');
  if (!target) return;
  var parentTarget = target.parentNode;

  sections._onSectionEvent({
    target: parentTarget,
    detail: {
      sectionId: sectionId
    },
    type: 'shopify:section:unload'
  });
  sections._onSectionEvent({
    target: parentTarget,
    detail: {
      sectionId: sectionId
    },
    type: 'shopify:section:load'
  });
};

var ProductPage = function ProductPage() {
  (0, _classCallCheck3.default)(this, ProductPage);

  this.el = document.body;

  sections.register('static-product-react', function (section) {
    return new _StaticProductReact2.default(section);
  });
  sections.register('product-features', function (section) {
    return new _ProductFeatures2.default(section);
  });
  sections.register('static-exit-intent', function (section) {
    return new _StaticExitIntent2.default(section);
  });

  document.addEventListener('product-change', function () {
    reloadSection('product-features');
    reloadSection('static-exit-intent');

    _rimgShopify2.default.watch(document.getElementById('shopify-section-product-features'));
    _rimgShopify2.default.watch(document.getElementById('shopify-section-static-exit-intent'));
    document.dispatchEvent(new CustomEvent('ga:update'));
  });

  _rimgShopify2.default.init();
};

exports.default = ProductPage;


new ProductPage();